import { createFileRoute, Outlet, redirect, useLocation } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';
import { resolveDashboardRoleRedirect } from '../modules/dashboard/lib/resolveDashboardRoleRedirect';
import { DashboardPage } from '../modules/dashboard/ui/pages/DashboardPage';

function DashboardRoute() {
  const location = useLocation();

  if (location.pathname.startsWith('/dashboard/')) {
    return <Outlet />;
  }

  return <DashboardPage />;
}

export const Route = createFileRoute('/_authenticated/dashboard')({
  // role-based-dashboards — Phase 5.1: role-dispatch on the bare `/dashboard`
  // landing route only. The exact-pathname gate (not `startsWith`) is
  // delegated to `resolveDashboardRoleRedirect` (FIX 5, review) — this route
  // file is the LAYOUT for every `/dashboard/*` child route (analytics,
  // tickets, sms/undelivered, etc.), so an unconditional redirect here would
  // also fire for those children and bounce a supervisor away from e.g.
  // `/dashboard/analytics`, which they ARE allowed to view (nav.ts
  // `requiredRoles: ['org_admin', 'supervisor']`). The parent
  // `_authenticated` layout already redirects unauthenticated users to
  // `/login`; the explicit re-check here just mirrors the existing
  // defense-in-depth convention (see `_authenticated.dashboard.supervisor.index.tsx`).
  beforeLoad: ({ location }) => {
    const session = getCurrentSession();
    if (!session) {
      throw redirect({ to: '/login' });
    }
    const target = resolveDashboardRoleRedirect(location.pathname, session.user.role);
    if (target) {
      throw redirect({ to: target });
    }
  },
  component: DashboardRoute,
  staticData: {
    breadcrumb: ['Overview', 'Dashboard'],
  },
});
